"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IecFileSizeUnit = exports.MetricFileSizeUnit = exports.FileSizeUnitBase = void 0;
exports.getFileSizeUnit = getFileSizeUnit;
exports.getFileSizeValue = getFileSizeValue;
exports.toFileSize = toFileSize;
exports.fileSizeToString = fileSizeToString;
exports.sumFileSize = sumFileSize;
exports.currencyFileSize = currencyFileSize;
exports.fileSizePercent = fileSizePercent;
exports.fileSizeRemain = fileSizeRemain;
exports.sumFileSizeToUnit = sumFileSizeToUnit;
var FileSizeUnitBase;
(function (FileSizeUnitBase) {
    FileSizeUnitBase[FileSizeUnitBase["metric"] = 1000] = "metric";
    FileSizeUnitBase[FileSizeUnitBase["iec"] = 1024] = "iec";
})(FileSizeUnitBase || (exports.FileSizeUnitBase = FileSizeUnitBase = {}));
// 1000
exports.MetricFileSizeUnit = {
    kilobyte: 'KB', // 1000 Byte
    megabyte: 'MB',
    gigabyte: 'GB',
    terabyte: 'TB',
    petabyte: 'PB'
};
// 1024
exports.IecFileSizeUnit = {
    kibibyte: 'Ki', // 1024 Byte
    mebibyte: 'Mi',
    gibibyte: 'Gi',
    tebibyte: 'Ti',
    pebibyte: 'Pi'
};
function isIecUnit(unit) {
    var _a;
    return (((_a = Object.values(exports.IecFileSizeUnit).filter(function (iec) { return iec.toLowerCase() === (unit === null || unit === void 0 ? void 0 : unit.toLowerCase()); })) === null || _a === void 0 ? void 0 : _a[0]) || '');
}
function isMetricUnit(unit) {
    var _a;
    return (((_a = Object.values(exports.MetricFileSizeUnit).filter(function (metric) { return metric.toLowerCase() === (unit === null || unit === void 0 ? void 0 : unit.toLocaleLowerCase()); })) === null || _a === void 0 ? void 0 : _a[0]) || '');
}
function fileSizeToByte(fileSize) {
    var _a;
    var unitBase = (_a = fileSize.unitBase) !== null && _a !== void 0 ? _a : FileSizeUnitBase.iec;
    var baseUnitArray = unitBase === FileSizeUnitBase.iec
        ? Object.values(exports.IecFileSizeUnit)
        : Object.values(exports.MetricFileSizeUnit);
    var amount = baseUnitArray.indexOf(fileSize.unit);
    if (amount < 0) {
        return fileSize.size;
    }
    return fileSize.size * Math.pow(unitBase, amount + 1);
}
function getFileSizeUnit(quota) {
    var _a;
    var unit = ((_a = quota === null || quota === void 0 ? void 0 : quota.match(/[A-Z]|[a-z]/g)) === null || _a === void 0 ? void 0 : _a.join('')) || '';
    if (!unit) {
        return null;
    }
    var iecUnit = isIecUnit(unit);
    var metricUnit = isMetricUnit(unit);
    return {
        unit: iecUnit || metricUnit || exports.IecFileSizeUnit.kibibyte,
        unitBase: metricUnit ? FileSizeUnitBase.metric : FileSizeUnitBase.iec
    };
}
function getFileSizeValue(quota) {
    var _a;
    return Number(((_a = quota === null || quota === void 0 ? void 0 : quota.match(/[0-9]|\./g)) === null || _a === void 0 ? void 0 : _a.join('')) || '0');
}
/**
 * "1000" => 1KB
 * @param quota
 * @returns
 */
function toFileSize(quota) {
    var unit = getFileSizeUnit(quota);
    var size = getFileSizeValue(quota);
    if (!unit) {
        // use 1024, Ki as default
        return {
            size: size / FileSizeUnitBase.iec,
            unit: exports.IecFileSizeUnit.kibibyte,
            unitBase: FileSizeUnitBase.iec
        };
    }
    return __assign({ size: size }, unit);
}
function fileSizeToString(fileSize, toFixed) {
    if (toFixed === void 0) { toFixed = 2; }
    var size = Number.isInteger(fileSize.size)
        ? fileSize.size
        : Number(fileSize.size.toFixed(toFixed));
    return "".concat(size).concat(fileSize.unit);
}
/**
 * final result's unitbase will be the first one in arrr
 * file size summary returns in KB or Ki
 * @param fileSizes
 * @returns
 */
function sumFileSize(fileSizes) {
    if (fileSizes.length === 0) {
        return {
            size: 0,
            unit: exports.IecFileSizeUnit.kibibyte,
            unitBase: FileSizeUnitBase.iec
        };
    }
    var fileSizeByte = fileSizes.reduce(function (acc, fileSize) {
        var fileSizeByte = fileSizeToByte(fileSize);
        return acc + fileSizeByte;
    }, 0);
    var unitBase = fileSizes[0].unitBase || FileSizeUnitBase.iec;
    return {
        size: fileSizeByte / unitBase, // KB or Ki
        unit: fileSizes[0].unitBase === FileSizeUnitBase.iec
            ? exports.IecFileSizeUnit.kibibyte
            : exports.MetricFileSizeUnit.kilobyte,
        unitBase: unitBase
    };
}
/**
 * convert between different unit
 * @param fileSize
 * @param targetUnit
 * @returns
 */
function currencyFileSize(fileSize, targetUnit) {
    var sizeByte = fileSizeToByte(fileSize);
    var unitBase = isIecUnit(targetUnit)
        ? FileSizeUnitBase.iec
        : FileSizeUnitBase.metric;
    var baseUnitArray = unitBase === FileSizeUnitBase.iec
        ? Object.values(exports.IecFileSizeUnit)
        : Object.values(exports.MetricFileSizeUnit);
    var index = baseUnitArray.indexOf(targetUnit);
    if (index < 0) {
        return fileSize;
    }
    return {
        size: sizeByte / Math.pow(unitBase, index + 1),
        unit: targetUnit,
        unitBase: unitBase
    };
}
/**
 * used 32 Ki
 * all 100 KB
 * Return 32.76%
 * @param used
 * @param all
 * @returns
 */
function fileSizePercent(used, all, toFixed) {
    if (toFixed === void 0) { toFixed = 2; }
    var usedFileSizeByte = fileSizeToByte(toFileSize(used));
    var allFileSizeByte = fileSizeToByte(toFileSize(all));
    var percent = (usedFileSizeByte / allFileSizeByte) * 100;
    return Number.isInteger(percent) ? percent : Number(percent.toFixed(toFixed));
}
function fileSizeRemain(used, all, targetUnit) {
    if (targetUnit === void 0) { targetUnit = exports.IecFileSizeUnit.gibibyte; }
    var usedFileSizeByte = fileSizeToByte(toFileSize(used));
    var allFileSizeByte = fileSizeToByte(toFileSize(all));
    var remain = allFileSizeByte - usedFileSizeByte;
    var unitBase = FileSizeUnitBase.iec;
    return currencyFileSize({
        size: remain / FileSizeUnitBase.iec,
        unit: exports.IecFileSizeUnit.kibibyte,
        unitBase: unitBase
    }, targetUnit);
}
function sumFileSizeToUnit(quotas, targetUnit, toFixed) {
    if (targetUnit === void 0) { targetUnit = exports.IecFileSizeUnit.gibibyte; }
    if (toFixed === void 0) { toFixed = 2; }
    var sums = sumFileSize((quotas === null || quotas === void 0 ? void 0 : quotas.map(function (quota) { return toFileSize(quota); })) || []);
    var fileSizeWithUnit = currencyFileSize(sums, targetUnit);
    return fileSizeToString(fileSizeWithUnit, toFixed);
}
